import axios from 'axios';
import { Auth } from 'aws-amplify';
import download from 'downloadjs';
import { HttpRequest } from './HttpRequest';
import { baseUrl } from 'utils/ApiRoutes';

export const actUser = async (email: any, role: any) => {
  try {
    const URL = `${baseUrl}/modificarPerfil`;
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();
    const data = {
      role,
      userName: email,
    };
    axios
      .put(URL, data, {
        headers: {
          Authorization: idToken,
        },
      })
      .then((res) => {
        window.location.reload();
      });
  } catch (e) {
    throw new Error(e);
  }
};

export const delUser = async (email: any): Promise<any> => {
  try {
    const URL = `${baseUrl}/eliminarUsuario`;
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();
    axios
      .delete(URL, {
        headers: {
          Authorization: idToken,
        },
        data: {
          userName: email,
        },
      })

      .then((res) => {
        window.location.reload();
      });
  } catch (e) {
    throw new Error(e);
  }
};

export const statusUser = async (email: any, status: any): Promise<any> => {
  try {
    const URL = `${baseUrl}/estadoUsuario`;
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();
    const data = {
      userName: email,
      estado: status,
    };
    axios
      .put(URL, data, {
        headers: {
          Authorization: idToken,
        },
      })
      .then((res) => {
        window.location.reload();
      });
  } catch (e) {
    throw new Error(e);
  }
};

export const downloadPdf = async (
  numCot: any,
  nameInsurer: any,
  onError: (text: string) => void
): Promise<any> => {
  try {
    const currentSession = await Auth.currentSession();
    const idToken = currentSession.getIdToken().getJwtToken();
    const URL = `${baseUrl}/generarCotizacion/${numCot}/${nameInsurer}`;
    let res;
    axios
      .get(URL, {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
          Authorization: idToken,
        },
      })
      .then((response) => {
        const content = response.headers['content-type'];
        download(response.data, `${numCot}.pdf`, content);
        res = content;
      });
    return res;
  } catch (err) {
    throw onError(`cotizacion no encontrada ${err}`);
  }
};

export const statusPdf = async (
  numCot: any,
  nameInsurer: any,
  onError: (text: string) => void
): Promise<any> => {
  try {
    const users = await new HttpRequest().Get<any>(
      `${baseUrl}/generarCotizacion/${numCot}/${nameInsurer}`
    );

    return users.data;
  } catch (err) {
    throw onError('No se encontro la cotizacion');
  }
};
